import { InjectionToken } from '@angular/core';
export const POPOVER_DEFAULT_CONFIG = new InjectionToken('mhe-popover-default-options');
export const POPOVER_DATA = new InjectionToken('popover.data');
